<template>
  <div
      v-if="hasCode && shouldUsePlaceholder"
      class="flag-placeholder"
      :style="{ width: width + 'px', height: height + 'px' }"
      :aria-label="flagAlt"
      role="img"
  >
    <span class="flag-placeholder__neutral" aria-hidden="true">--</span>
  </div>

  <img
      v-else-if="hasCode"
      class="country-flag-image"
      :src="flagSrc"
      :srcset="flagSrcSet"
      :width="width"
      :height="height"
      :alt="flagAlt"
      @error="handleFlagError"
  />
</template>

<script>
export default {
  name: 'CountryFlag',

  props: {
    codeIso: { type: String, required: true },
    width: { type: Number, default: 24 },
    height: { type: Number, default: 18 }
  },

  data () {
    return {
      hasFlagError: false
    }
  },

  computed: {
    code () {
      return (this.codeIso || '').toLowerCase()
    },

    hasCode () {
      return !!this.code
    },

    isValidFlagCode () {
      return /^[a-z]{2}$/.test(this.code) && this.code !== 'um'
    },

    shouldUsePlaceholder () {
      return !this.isValidFlagCode || this.hasFlagError
    },

    flagSrc () {
      return `https://flagcdn.com/${this.width}x${this.height}/${this.code}.png`
    },

    flagSrcSet () {
      return `
      https://flagcdn.com/${this.width * 2}x${this.height * 2}/${this.code}.png 2x,
      https://flagcdn.com/${this.width * 3}x${this.height * 3}/${this.code}.png 3x
    `
    },

    flagAlt () {
      return this.shouldUsePlaceholder ? 'Unknown location' : this.code.toUpperCase()
    }
  },

  watch: {
    codeIso () {
      this.hasFlagError = false
    }
  },

  methods: {
    handleFlagError () {
      if (!this.hasFlagError) {
        this.hasFlagError = true
      }
    }
  }
}
</script>

<style scoped>
.flag-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef1f6 0%, #d8dee8 100%);
  border: 1px solid #c4ccd8;
  border-radius: 2px;
}

.flag-placeholder__neutral {
  color: rgba(95, 108, 129, 0.8);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1;
}

.country-flag-image {
  object-fit: cover;
  border-radius: 2px;
}
</style>
